import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'CustomMenuLinkService'
const host = servicesConfig.CustomMenuLinks as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const CustomMenuLinkService = {
  getCustomMenuLink: (companyId: string, skip: number, limit: number, locationId?: string) => {
    if (locationId) {
      return request().get(`/?companyId=${companyId}&locationId=${locationId}&skip=${skip}&limit=${limit}`).then(responseBody)
    }
    return request().get(`/?companyId=${companyId}&showOnCompany=true&skip=${skip}&limit=${limit}`).then(responseBody)
  },
  
  getCustomMenuLinkById: (companyId: string, customMenuLinkId: string, locationId?: string) => {
    if (locationId) {
      return request().get(`/${customMenuLinkId}?companyId=${companyId}&locationId=${locationId}`).then(responseBody)
    } else {
      return request().get(`/${customMenuLinkId}?companyId=${companyId}`).then(responseBody)
    }
  }
}

export default CustomMenuLinkService